import React from 'react';
import { Upload } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';

import { Button, Icon } from 'components/ui';
import './UploadField.css';
import CSVWarning from './CSVWarning';

const UploadField = ({ data, disabled, isFetching }) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name="csvFiles"
        render={({ field, fieldState }) => {
          return (
            <>
              <Upload
                accept=".csv"
                beforeUpload={file => {
                  field.onChange([file]);
                  return false;
                }}
                disabled={!!disabled}
                fileList={field.value}
                onRemove={() => field.onChange([])}
              >
                <Button disabled={disabled} loading={isFetching} size="small">
                  <Icon type="upload" />
                  &nbsp;Upload CSV File
                </Button>
              </Upload>
              {fieldState.error && (
                <div style={{ fontSize: 12, color: 'red', paddingTop: 5 }}>
                  {fieldState.error?.message}
                </div>
              )}
            </>
          );
        }}
      />

      <CSVWarning data={data} />
    </>
  );
};

export default UploadField;
